"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Full Name*");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Club");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Year of Birth");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Gender*");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Is paddler a member of Paddle UK/Paddle Scotland/Paddle Cymbru?*");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Membership Nation");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Membership Number");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Country");
var _ref9 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Membership Number");
var _ref10 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, /*#__PURE__*/_react.default.createElement("p", null, "Please be aware that you may need to supply proof of your Paddle UK membership to the organiser."));
var _ref11 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, /*#__PURE__*/_react.default.createElement("p", null, "You will need event membership of Paddle UK to compete and will need to supply proof to the organiser."), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "If you live in England/Wales or are competing in England/Wales, then please go to", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "https://paddleuk.org.uk/purchase-sem/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Paddle UK Single Event Membership"), ' ', "and search on the competition name to buy event membership."), /*#__PURE__*/_react.default.createElement("li", null, "If you both live in Scotland and are competing in Scotland, you can still choose to use the link, but may benefit from contacting the organiser at the competition instead, as Scotland offer a subsequent upgrade to full membership at a discount.")));
class NonRankedFromScratch extends _react.Component {
  render() {
    const scratchPaddler = this.props.scratchPaddler;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 5
      }, {
        sm: 7
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "paddlerName",
      value: scratchPaddler.paddlerName,
      onChange: this.props.setValue.bind(this, 'paddlerName'),
      maxLength: 100,
      required: true
    }))), this.props.isInternational || this.props.isNonPaddler ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "PaddlerClubs",
      value: scratchPaddler.paddlerClubID,
      onChange: this.props.setValue.bind(this, 'paddlerClubID'),
      clearable: true,
      yearID: this.props.yearID
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Year",
      name: "yearOfBirth",
      value: scratchPaddler.yearOfBirth,
      onChange: this.props.setValue.bind(this, 'yearOfBirth'),
      maxLength: 4
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, this.props.genderDescription || this.props.genders.refCodes.filter(ref => !ref.isExpired).map(gender => /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 4,
      key: gender.refCode
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "genderRef",
      value: gender.refCode,
      checked: scratchPaddler.genderRef === gender.refCode,
      onChange: this.props.setValue.bind(this, 'genderRef'),
      label: gender.description
    }))))), this.props.isInternational || this.props.isNonPaddler ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 4
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "isBCMember",
      value: "yes",
      checked: scratchPaddler.isBCMember === 'yes',
      onChange: this.props.setValue.bind(this, 'isBCMember'),
      label: "Yes"
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 4
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "isBCMember",
      value: "no",
      checked: scratchPaddler.isBCMember === 'no',
      onChange: this.props.setValue.bind(this, 'isBCMember'),
      label: "No"
    })))), scratchPaddler.isBCMember !== 'yes' ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "nation",
      value: scratchPaddler.membershipNationRef,
      onChange: this.props.setValue.bind(this, 'membershipNationRef'),
      required: scratchPaddler.isBCMember === 'yes'
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "bcNumber",
      value: scratchPaddler.bcNumber,
      onChange: this.props.setValue.bind(this, 'bcNumber'),
      maxLength: 50,
      required: scratchPaddler.isBCMember === 'yes'
    })))), !this.props.isInternational ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "country",
      value: scratchPaddler.countryRef,
      onChange: this.props.setValue.bind(this, 'countryRef'),
      required: this.props.isInternational
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref9, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "bcNumber",
      value: scratchPaddler.bcNumber,
      onChange: this.props.setValue.bind(this, 'bcNumber'),
      maxLength: 50,
      required: this.props.isInternational
    })))))), scratchPaddler.isBCMember === 'yes' ? _ref10 : scratchPaddler.isBCMember === 'no' ? _ref11 : null);
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(NonRankedFromScratch, "partialQueries", {
  NonRankedPaddler: {
    id: true,
    paddlerName: true,
    yearOfBirth: true,
    paddlerClubID: true,
    isBCMember: true,
    bcNumber: true,
    genderRef: true
  }
});
var _ref12 = {
  "codeType(id:\"gender\") as genders": {
    refCodes: {
      refCode: true,
      description: true,
      isExpired: true
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(NonRankedFromScratch, props => _ref12);